export const DELIVERY_CHARGE_INSIDE = process.env.REACT_APP_DELIVERY_CHARGE_INSIDE;
export const DELIVERY_CHARGE_OUTSIDE = process.env.REACT_APP_DELIVERY_CHARGE_OUTSIDE;
export const DELIVERY_TIME_INSIDE = process.env.REACT_APP_DELIVERY_TIME_INSIDE;
export const DELIVERY_TIME_OUTSIDE_MIN = process.env.REACT_APP_DELIVERY_TIME_OUTSIDE_MIN;
export const DELIVERY_TIME_OUTSIDE_MAX = process.env.REACT_APP_DELIVERY_TIME_OUTSIDE_MAX;
export const DELIVERY_NOTE = process.env.REACT_APP_DELIVERY_NOTE;